(() => {
  if (window.CaventoCartPage) return;
  window.CaventoCartPage = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cavento-cart-add]');
    if (!button || button.disabled) return;

    const itemsSection = document.getElementById('main-cart-items');
    const footerSection = document.getElementById('main-cart-footer');
    if (!itemsSection || !footerSection) return;

    button.disabled = true;
    button.classList.add('loading');

    const sectionIds = [itemsSection.dataset.id, footerSection.dataset.id, 'cart-icon-bubble'];

    try {
      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig('json'),
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: sectionIds,
          sections_url: routes.cart_url,
        }),
      });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || state.message || 'Toevoegen mislukt');

      const parser = new DOMParser();
      const replacements = [
        { id: itemsSection.dataset.id, target: '#main-cart-items .js-contents', source: '.js-contents' },
        { id: footerSection.dataset.id, target: '#main-cart-footer .js-contents', source: '.js-contents' },
        { id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' },
      ];

      replacements.forEach(({ id, target, source }) => {
        if (!state.sections?.[id]) return;
        const targetElement = document.querySelector(target);
        const sourceDocument = parser.parseFromString(state.sections[id], 'text/html');
        const sourceElement = sourceDocument.querySelector(source);
        if (targetElement && sourceElement) targetElement.innerHTML = sourceElement.innerHTML;
      });

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cavento-cart-page-upsell', cartData: state });
      }
    } catch (error) {
      const errors = document.getElementById('cart-errors');
      if (errors) errors.textContent = error.message;
      button.disabled = false;
      button.classList.remove('loading');
    }
  });
})();
